export default class TypePaymentInsurance {
  id!: number
  payment_method!: string
  isEdit!: boolean
}
